window.addEventListener("load", function () {
    // Initialize Swiper to show 1 item at a time
    const eventSwiper = new Swiper(".list_event", {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        spaceBetween: 30,
        navigation: {
            nextEl: ".swiper-button-next.next-event",
            prevEl: ".swiper-button-prev.prev-event",
        },
       
    });
});
